// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"605":"7062effd","721":"1a83e528","800":"39776df7","919":"91d73fe5","927":"89cdbb25"}[chunkId] + ".chunk.js";
};